import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LogRocket from 'logrocket';

if (!window.location.href.includes('localhost')) {
  LogRocket.init('bmiwre/portfolio');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);